import AlertCreator from 'components/AlertCreator/AlertCreator';
import Doppler from 'components/Maps/Doppler/Doppler';
import EarthquakeMap from 'components/Maps/Earthquake/EarthquakeMap';
import { AirportDelay } from 'components/SpecialReports/AirportDelay';
import { FireDanger } from 'components/SpecialReports/FireDanger';
import { SkiReports } from 'components/SpecialReports/SkiReports';
import HurricanesTropicalStorms from 'components/StormCenter/HurricanesTropicalStorms';
import AirQualityForecastWidget from 'components/Widgets/AirQualityForecastWidget';
import AirQualityObservationsWidget from 'components/Widgets/AirQualityObservationsWidget';
import BuoyConditionsWidget from 'components/Widgets/BuoyConditionsWidget';
import CombinedChartsWidget from 'components/Widgets/CombinedChartsWidget';
import DayForecast15Widget from 'components/Widgets/DayForecast15Widget';
import DetailedForecast from 'components/Widgets/DetailedForecast';
import DeviceGroupWidget from 'components/Widgets/DeviceGroupWidget';
import MyAdvisoriesWidget from 'components/Widgets/MyAdvisoriesWidget';
import NWSAlertsWidget from 'components/Widgets/NWSAlertsWidget';
import SurfAlertsWidget from 'components/Widgets/SurfAlertsWidget';
import TideTableWidget from 'components/Widgets/TideTableWidget';
import WaveAndWindConditionsWidget from 'components/Widgets/WaveAndWindConditionsWidget';
import WeatherForecastWidget from 'components/Widgets/WeatherForecastWidget';
import ExacqVisionVMSWidget from 'features/exacqvision-vms/ExacqVisionVMS.widget';
import ConnectedDevicesWidget from 'features/integrations/features/ConnectedDevices/index.web.widget';
import Connections from 'pages/System/Connections';
import Alerts from 'pages/Weather/Alerts';
import MapForecast from 'widgets/MapForecast.js';
import SevereWeatherAlertsMap from 'widgets/SevereWeatherAlerts.js';
import { createWidgetRendererHelpers } from './widgetHelpers';
import USGSMapWidget from 'features/integrations/features/ConnectedDevices/widgets/USGSMapWidget';

export const getWidgetRenderers = (
  widgetRefresh,
  setWidgetRefresh,
  sidebarOpen
) => {
  
  // Helper factory binds refresh/sidebar props once and returns widget renderers.
  const {
    renderWidget,
    renderConnectedDevices,
    renderConnectionsWidget,
  } = createWidgetRendererHelpers({ widgetRefresh, setWidgetRefresh, sidebarOpen });

  // Map widget id -> render function; widgetMeta references the same ids.
  return {
    1: renderWidget(SevereWeatherAlertsMap),
    2: renderWidget(WeatherForecastWidget),
    3: renderWidget(MapForecast),
    4: renderWidget(DetailedForecast, {}, { layoutPreset: 'forecastFit', clipOverflow: true }),
    5: renderWidget(DayForecast15Widget, {}, { layoutPreset: 'forecastFit', clipOverflow: true }),
    6: renderWidget(AirQualityObservationsWidget),
    7: renderWidget(AirQualityForecastWidget),
    8: renderWidget(NWSAlertsWidget),
    9: renderWidget(MyAdvisoriesWidget),
    10: renderWidget(WaveAndWindConditionsWidget),
    11: renderWidget(SurfAlertsWidget),
    12: renderWidget(BuoyConditionsWidget),
    13: renderWidget(TideTableWidget),
    14: renderWidget(EarthquakeMap, { widget: true }),
    15: renderWidget(HurricanesTropicalStorms, { widget: true }),
    16: renderWidget(CombinedChartsWidget, { defaultTab: 0 }),
    17: renderWidget(CombinedChartsWidget, { defaultTab: 1 }),
    18: renderWidget(CombinedChartsWidget, { defaultTab: 2 }),
    19: renderWidget(CombinedChartsWidget, { defaultTab: 3 }),
    20: renderWidget(CombinedChartsWidget, { defaultTab: 4 }),
    21: renderWidget(CombinedChartsWidget, { defaultTab: 5 }),
    22: renderWidget(CombinedChartsWidget, { defaultTab: 6 }),
    23: renderWidget(CombinedChartsWidget, { defaultTab: 7 }),
    24: renderWidget(CombinedChartsWidget, { defaultTab: 8 }),
    25: renderWidget(CombinedChartsWidget, { defaultTab: 9 }),
    26: renderWidget(CombinedChartsWidget, { defaultTab: 10 }),
    27: renderWidget(FireDanger, { widget: true }),
    28: renderWidget(AirportDelay, { widget: true }),
    29: renderWidget(SkiReports, { widget: true }),
    30: renderConnectedDevices("graph", ConnectedDevicesWidget),
    31: renderConnectedDevices("awareFloodMap", ConnectedDevicesWidget),
    32: renderWidget(Doppler, { widget: true }),

    // Custom alert filter stays local to this widget renderer.
    33: (w, h, preview) => (
      <Alerts
        widgetRefresh={widgetRefresh}
        setWidgetRefresh={setWidgetRefresh}
        sidebarOpen={sidebarOpen}
        dimensions={[w, h]}
        preview={preview}
        filterAlerts={(list) =>
          list.filter((item) => item.provider === 'Custom Weather')
        }
      />
    ),

    34: renderConnectionsWidget("technologyBridge", Connections),
    35: renderConnectionsWidget("manualRoadClosure", Connections),
    36: renderConnectionsWidget("technologyBridgeSiren", Connections),
    37: renderConnectedDevices("list", ConnectedDevicesWidget),

    38: (w, h) => <DeviceGroupWidget dimensions={[w, h]} />,

    39: (w,h) => <USGSMapWidget dimensions={[w,h]} />,

    101: renderWidget(Alerts),

    102: (w, h, preview) => (
      <AlertCreator
        sidebarOpen={sidebarOpen}
        widget
        dimensions={[w, h]}
        preview={preview}
      />
    ),
    103: () => <ExacqVisionVMSWidget />,
  };
};
